// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer__separator[data-v-6b04379a]:after {\n  content: \"|\";\n  margin: 0 10px;\n}\n.footer-text[data-v-6b04379a] {\n  font-size: 0.625rem;\n}\n.footer-text a[data-v-6b04379a] {\n  text-decoration: none;\n}\nfooter[data-v-6b04379a] {\n  border-top: 1px solid #e8eef1 !important;\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n}", ""]);
// Exports
module.exports = exports;
